import EventHandler from '@pixelunion/events';
import { transition } from '@pixelunion/animations';

export default class SiteOverlay {
  constructor() {
    this.events = new EventHandler();
    this.overlay = document.querySelector('[data-site-overlay]');
    this.animation = transition({ el: this.overlay, state: 'closed' });

    this.events.register(this.overlay, 'click', () => this.close());
  }

  open() {
    this.animation.animateTo('open');
  }

  close() {
    this.animation.animateTo('closed');
  }
}
